import { useEffect, useState } from 'react'

import classNames from 'classnames'
import { createPortal } from 'react-dom'

import './Popup.scss'

interface PopupProps {
  isOpen: boolean
  direction?: 'right' | 'left' | 'top' | 'bottom'
  children?: React.ReactNode
}

export const Popup: React.FC<PopupProps> = ({
  isOpen,
  direction = 'bottom',
  children,
}) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timeouts: NodeJS.Timeout[] = []

    if (isOpen) {
      timeouts.push(setTimeout(() => setShow(true), 0))
    } else {
      // wait for slideout animation
      timeouts.push(setTimeout(() => setShow(false), 300))
    }

    return () => timeouts.forEach(clearTimeout)
  }, [isOpen])

  if (!show) return null

  return createPortal(
    <div
      className={classNames('popup panel', direction, {
        [`animate-in-${direction}`]: show,
        [`animate-out-${direction}`]: !isOpen,
        ['is-open']: show,
      })}
    >
      {children}
    </div>,
    document.body,
  )
}
